import React from 'react'
import styles from './style.module.scss'
import PropTypes from 'prop-types'
import CustomTable from '@shared/components/olympics/common/customTable'
import MyImage from '@shared/components/myImage'
import { getImgURL } from '@shared-submodule/utils'
import FlagTeam from '@assets/images/placeholder/team-placeholder.jpg'
import Link from 'next/link'

export default function ChampionTable({ pointsData, isMobile = false }) {
  const generateBodyData = () => {
    return pointsData?.map((ele, index) => {
      return [
          <div key={index} className="d-flex">
            <div className={styles.title}>
              <MyImage src={getImgURL(ele?.oTeam?.oImg?.sUrl) || ''} placeholderImage={FlagTeam} height={24} width={24} />
            </div>
            { !isMobile ? (
              <Link href={`/${ele?.oTeam?.oSeo?.sSlug}`}>
                <a>
                <span className={styles.team}>{ele?.oTeam?.sAbbr}
                  {ele?.bIsTeamQualified && ' (Q)'}
                </span>
                </a>
              </Link>
            ) : (
              <span className={styles.team}>{ele?.oTeam?.sAbbr}
              {ele?.bIsTeamQualified && ' (Q)'}
              </span>
            )}
          </div>,
          ele?.nPlayed || 0,
          ele?.nWin || 0,
          ele?.nLoss || 0,
          ele?.nPoints || 0
      ]
    })
  }

  const bodyData = generateBodyData()

  const tableData2 = {
    header: ['Team', 'Played', 'W', 'L', 'PTS'],
    body: bodyData
  }

  return (
    <div className='d-flex flex-column' style={{ width: '-webkit-fill-available' }}>
      <h4>Points Table</h4>
      <div className={styles.leaguePointsTable}>
        <CustomTable table={tableData2} noData={pointsData?.length <= 0} smallTable isChess />
      </div>
    </div>
  )
}

ChampionTable.propTypes = {
  pointsData: PropTypes.array,
  isMobile: PropTypes.bool
}
